import React from "react";
import wavesBlue from "src/assets/imgs/waves-blue.png";
import { useTranslation } from "src/context/Translations/context";
import { Container, Content, Background, AnimationContainer } from "./styles";
import { IComponentLoginScreen } from "./interface";

const LoginScreen: React.FC<IComponentLoginScreen> = ({
	children,
	contentPosition,
	style
}) => {
	const {translate} = useTranslation();
	return (
		<Container style={style}>
			<Content style={contentPosition === "end" ? { order: 2 } : {}}>
				<AnimationContainer>
					<img src="/logo.png" className="main-logo" alt="Scoreplan Logo"/>
					{children}
				</AnimationContainer>
				<img src={wavesBlue} className="waves-blue" alt="Ondas Azuis" />
			</Content>
			<Background>
				<img src="/logo-white-letters.png" alt="Scoreplan Logo" className="logo" />
				<div className="big-letters-login">
					{translate("Planejamento")},
					<p>
						{translate("execução")},
					</p>
					{translate("análise")}
					<p>
						{translate("e resultado")}!
					</p>
				</div>
				<div>{translate("O sistema mais completo do mercado")}<p>{translate("para o Planejamento Estratégico e Orçamentário das Empresas")}</p></div>
				<img src="/logo-background.png" alt="Scoreplan Logo Background" className="logo-background" />
			</Background>
		</Container>
	);
};

export default LoginScreen;
